import { Globe, Cpu, Workflow, Smartphone, Wrench, Server, Bot, Code2 } from "lucide-react";

export const ICONS = { globe: Globe, cpu: Cpu, workflow: Workflow, smartphone: Smartphone, wrench: Wrench, server: Server, bot: Bot, code: Code2 };

export function ServiceIcon({ name, className = "h-6 w-6" }) {
  const Ico = ICONS[name] || Wrench;
  return <Ico className={className} />;
}

export function SectionLabel({ children }) {
  return <p className="font-mono text-xs tracking-[0.25em] uppercase text-electric mb-3">{`</> ${children}`}</p>;
}

export function priceLabel(p) {
  if (p.priceDisplay) return p.priceDisplay;
  if (p.quoteBased) return "Quote based";
  if (p.minPrice != null && p.maxPrice != null && p.minPrice !== p.maxPrice)
    return `$${p.minPrice.toLocaleString()}–$${p.maxPrice.toLocaleString()}`;
  if (p.minPrice != null) return `${p.startingAt ? "From " : "$"}$${p.minPrice.toLocaleString()}`.replace("$$", "$");
  return "Contact us";
}
